import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: '',
		component: () => import(/* webpackChunkName: "home" */ '../layouts/DefaultLayout.vue'),
		children: [
			{
				path: '/',
				name: 'Home',
				component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
			},
			{
				path: '/auth/login',
				name: 'Login',
				component: () => import(/* webpackChunkName: "home" */ '../views/auth/Login.vue')
			},
			{
				path: '/terms-conditions',
				name: 'Terms & Conditions',
				component: () => import(/* webpackChunkName: "privacy" */ '../views/privacy/TermsConditions.vue')
			},
			{
				path: '/privacy-policy',
				name: 'Privacy Policy',
				component: () => import(/* webpackChunkName: "privacy" */ '../views/privacy/PrivacyPolicy.vue')
			},
			{
				path: 'bot/auth',
				name: 'FluxBot Login',
				component: () => import(/* webpackChunkName: "bot" */ '../views/bot/LoginView.vue'),
			},
			{ //Free Views
				path: 'gems',
				name: 'Gems',
				component: () => import(/* webpackChunkName: "gems" */ '../views/trading/Gems.vue'),
			},
			{
				path: 'trending',
				name: 'Trending',
				component: () => import(/* webpackChunkName: "trending" */ '../views/trading/TrendingTokens.vue')
			},
			{
				path: 'social',
				name: 'Social',
				component: () => import(/* webpackChunkName: "settings" */ '../views/social/Social.vue')
			},
			{
				path: 'social/:id',
				name: 'Social Item',
				component: () => import(/* webpackChunkName: "settings" */ '../views/social/SocialItem.vue')
			},
		]
	},
	{
		path: '/app',
		name: '',
		component: () => import(/* webpackChunkName: "auth_app" */ '../layouts/AuthenticatedLayout.vue'),
		children: [
			{
				path: 'automations',
				name: 'Automations',
				component: () => import(/* webpackChunkName: "automations" */ '../views/automation/Index.vue')
			},
			{
				path: 'automations/create',
				name: 'New Automation',
				component: () => import(/* webpackChunkName: "automations" */ '../views/automation/Create.vue')
			},
			{
				path: 'automations/:id',
				name: 'Automation',
				component: () => import(/* webpackChunkName: "automations" */ '../views/automation/Show.vue')
			},
			{
				path: 'trending',
				name: 'Trending Tokens',
				component: () => import(/* webpackChunkName: "trending" */ '../views/trading/TrendingTokens.vue')
			},
			{
				path: 'bridge',
				name: 'Bridge',
				component: () => import(/* webpackChunkName: "bridge" */ '../views/bridge/Bridge.vue')
			},
			{
				path: 'swap',
				name: 'Swap',
				component: () => import(/* webpackChunkName: "token" */ '../views/token/TokenSwap.vue')
			},
			{
				path: 'tokens',
				name: 'Tokens',
				component: () => import(/* webpackChunkName: "token" */ '../views/token/TokenIndex.vue')
			},
			{
				path: 'copy-trader',
				name: 'Copy Trader',
				component: () => import(/* webpackChunkName: "copy-trader" */ '../views/token/CopyTrader.vue')
			},
			{
				path: 'token-sniper',
				name: 'Token Sniper',
				component: () => import(/* webpackChunkName: "token-sniper" */ '../views/token/TokenSniper.vue')
			},
			{
				path: 'tokens/:id/transfer',
				name: 'Transfer Token',
				component: () => import(/* webpackChunkName: "token" */ '../views/token/TransferView.vue')
			},
			{
				path: 'liquidity',
				name: 'Liquidity',
				component: () => import(/* webpackChunkName: "liquidity" */ '../views/liquidity/LiquiditySwap.vue')
			},
			{
				path: 'pools',
				name: 'Pool Index',
				component: () => import(/* webpackChunkName: "pool" */ '../views/pools/PoolIndex.vue')
			},
			{
				path: 'migrations',
				name: 'Migration Index',
				component: () => import(/* webpackChunkName: "migration" */ '../views/migration/MigrationIndex.vue')
			},
			{
				path: 'markets',
				name: 'Openbook Markets',
				component: () => import(/* webpackChunkName: "pool" */ '../views/pools/MarketIndex.vue')
			},
			{
				path: 'markets/create',
				name: 'Market Create',
				component: () => import(/* webpackChunkName: "pool" */ '../views/pools/MarketCreate.vue')
			},
			{
				path: 'pools/create',
				name: 'Pool Create',
				component: () => import(/* webpackChunkName: "pool" */ '../views/pools/PoolCreate.vue')
			},
			{
				path: 'pools/:id',
				name: 'Pool Show',
				component: () => import(/* webpackChunkName: "pool" */ '../views/pools/PoolShow.vue')
			},
			{
				path: 'nfts/pools/create',
				name: 'NFT Pool Create',
				component: () => import(/* webpackChunkName: "nft_pool" */ '../views/pools/NFTPoolCreate.vue')
			},
			{
				path: 'nfts/pools',
				name: 'NFT Pools',
				component: () => import(/* webpackChunkName: "nft_pool" */ '../views/nft/pools/PoolIndex.vue')
			},
			{
				path: 'nfts/pools/:id',
				name: 'NFT Pool',
				component: () => import(/* webpackChunkName: "nft_pool" */ '../views/nft/pools/PoolShow.vue')
			},
			{
				path: 'profile',
				name: 'Profile',
				component: () => import(/* webpackChunkName: "profile" */ '../views/profile/ProfileIndexNext.vue')
			},
			{
				path: 'profile/:id',
				name: 'Trader Profile',
				component: () => import(/* webpackChunkName: "profile_public" */ '../views/profile/PublicProfileIndexNext.vue')
			},
			{
				path: 'settings',
				name: 'User Settings',
				component: () => import(/* webpackChunkName: "settings" */ '../views/SettingViewNext.vue')
			},

			{
				path: 'lockers/:id',
				name: 'Locker',
				component: () => import(/* webpackChunkName: "lockers" */ '../views/lockers/FluxLockerShow.vue'),
			},
			{
				path: 'tools',
				name: '',
				component: () => import(/* webpackChunkName: "tools" */ '../views/tools/ToolsIndex.vue'),
			},
			{
				path: 'tools/token_launcher',
				name: 'Token Launcher',
				component: () => import(/* webpackChunkName: "tools_token_create" */ '../views/tools/TokenLauncher.vue')
			},
			{
				path: 'tools/token_create',
				name: 'Token Create',
				component: () => import(/* webpackChunkName: "tools_token_create" */ '../views/tools/TokenCreate.vue')
			},
			{
				path: 'tools/token_create_v1',
				name: 'Token Create v1',
				component: () => import(/* webpackChunkName: "tools_token_v1_create" */ '../views/tools/TokenCreateV1.vue')
			},
			{
				path: 'tools/wrap',
				name: 'Token Wrap',
				component: () => import(/* webpackChunkName: "tools_wrap_sol" */ '../views/tools/WrapSol.vue')
			},
			{
				path: 'tools/fee_manager',
				name: 'Fee Manager',
				component: () => import(/* webpackChunkName: "tools_fee_manager" */ '../views/tools/FeeManager.vue')
			},
			{
				path: 'tools/fee_manager_automated',
				name: 'Automated Fee Manager',
				component: () => import(/* webpackChunkName: "fee_manager_automated" */ '../views/tools/FeeManagerAdvanced.vue')
			},
			{
				path: 'tools/token_manager',
				name: 'Token Manager',
				component: () => import(/* webpackChunkName: "tools_token_manager" */ '../views/tools/TokenManager.vue')
			},
			{
				path: 'tools/token_metadata',
				name: 'Token Metadata',
				component: () => import(/* webpackChunkName: "tools_token_manager" */ '../views/tools/MetadataUpdate.vue')
			},
			{
				path: 'tools/token_transfer',
				name: 'Token Transfer',
				component: () => import(/* webpackChunkName: "tools_token_transfer" */ '../views/token/TransferView.vue')
			},
			{
				path: 'tools/token_burn',
				name: 'Token Burn',
				component: () => import(/* webpackChunkName: "tools_token_burn" */ '../views/token/BurnView.vue')
			},
			{
				path: 'tools/token_mint',
				name: 'Token Mint',
				component: () => import(/* webpackChunkName: "tools_token_mint" */ '../views/token/MintView.vue')
			},
			{
				path: 'tools/token_withheld_amount',
				name: 'Token Withheld Amount',
				component: () => import(/* webpackChunkName: "tools_withheld_amount" */ '../views/tools/WithheldAmount.vue')
			},
			{
				path: 'tools/token_verify',
				name: 'Token Verification',
				component: () => import(/* webpackChunkName: "tools_token_verify" */ '../views/tools/VerifyView.vue')
			},
			{
				path: 'tools/token_airdrop',
				name: 'Token Airdrop',
				component: () => import(/* webpackChunkName: "tools_token_airdrop" */ '../views/tools/TokenAirdrop.vue')
			},
			{
				path: 'tools/token_migration',
				name: 'Token Migration',
				component: () => import(/* webpackChunkName: "tools_token_migration" */ '../views/migration/MigrationCreate.vue')
			},
			{
				path: 'tools/token_locker',
				name: 'Token Locker',
				component: () => import(/* webpackChunkName: "tools_token_locker" */ '../views/tools/TokenLocker.vue')
			},
			{
				path: 'tools/transaction_send',
				name: 'Transaction Sender',
				component: () => import(/* webpackChunkName: "tools_txn_sender" */ '../views/tools/TransactionSend.vue')
			},
			{
				path: 'tools/swap_api',
				name: 'Swap API Tester',
				component: () => import(/* webpackChunkName: "tools_txn_sender" */ '../views/tools/SwapAPITester.vue')
			},
			// {
			// 	path: 'tools/token_launch',
			// 	name: 'Token Launch',
			// 	component: () => import(/* webpackChunkName: "tools_token_launch" */ '../views/tools/TokenLaunch.vue')
			// },
			// {
			// 	path: 'tools/spl22/bridge',
			// 	name: 'SPL22 Bridge',
			// 	component: () => import(/* webpackChunkName: "tools_token_launch" */ '../views/tools/TokenLaunch.vue')
			// },
			// {
			// 	path: 'spl22/pools',
			// 	name: 'SPL22 Pools',
			// 	component: () => import(/* webpackChunkName: "tools_token_launch" */ '../views/spl22/PoolIndex.vue')
			// },
			// {
			// 	path: 'spl22/pools/:id',
			// 	name: 'SPL22 Pool',
			// 	component: () => import(/* webpackChunkName: "tools_token_launch" */ '../views/spl22/PoolShow.vue')
			// },
			// {
			// 	path: 'nfts/hot_or_not',
			// 	name: 'Hot Or Not',
			// 	component: () => import(/* webpackChunkName: "nfts_hot_or_not" */ '../views/nfts/hot_or_not/HotOrNot.vue')
			// },
			//
			// {
			// 	path: 'nfts/hot_or_not/rankings',
			// 	name: 'Hot Or Not Ranking',
			// 	component: () => import(/* webpackChunkName: "nfts_hot_or_not" */ '../views/nfts/hot_or_not/Rankings.vue')
			// },
			//
			// {
			// 	path: 'nfts/hot_or_not/:id',
			// 	name: 'Hot Or Not | Show',
			// 	component: () => import(/* webpackChunkName: "nfts_hot_or_not" */ '../views/nfts/hot_or_not/Show.vue')
			// },
			{
				path: 'points',
				name: 'FLUX Points Leaderboard',
				redirect: '/app/points/fees'
			},
			{
				path: 'points/pnl',
				name: 'FLUX PnL Leaderboard',
				component: () => import(/* webpackChunkName: "points_pnl" */ '../views/points/PnLLeaderboardView.vue'),
				props: (route) => ({
					timeframe: route.query.timeframe || 'daily'
				})
			},
			{
				path: 'points/fees',
				name: 'FLUX Fees Leaderboard',
				component: () => import(/* webpackChunkName: "points_fees" */ '../views/points/FeesLeaderboardView.vue'),
				props: (route) => ({
					timeframe: route.query.timeframe || 'daily'
				})
			},
			{
				path: "stats/top/traders",
				name: "Stats | Top Traders",
				component: () => import(/* webpackChunkName: "top_traders" */ '../views/stats/TopTraders.vue')
			},
			{
				path: "stats/top/positions",
				name: "Stats | Top Positions",
				component: () => import(/* webpackChunkName: "top_positions" */ '../views/analytics/TopPositions.vue')
			},
			{
				path: "stats/smart_money",
				name: "Stats | Smart Money",
				component: () => import(/* webpackChunkName: "smart_money" */ '../views/analytics/SmartMoney.vue')
			},
			{
				path: "stats/bot_volume",
				name: "Stats | Bot Volume",
				component: () => import(/* webpackChunkName: "bot_fees" */ '../views/analytics/BotFees.vue')
			},
			{
				path: "beta",
				name: "Beta Access",
				component: () => import(/* webpackChunkName: "beta" */ '../views/beta/Gate.vue')
			}
		]
	},
	{
		path: '/bot',
		name: '',
		component: () => import(/* webpackChunkName: "auth_app" */ '../layouts/BotLayout.vue'),
		children: [
			{
				path: 'portfolio/:id',
				name: 'Portfolio',
				component: () => import(/* webpackChunkName: "points" */ '../views/bot/PortfolioView.vue')
			},
		]
	},
	{
		path: '/',
		name: '',
		component: () => import(/* webpackChunkName: "auth_app" */ '../layouts/DefaultLayout.vue'),
		children: [
			{
				path: "/:id(.*)*",
				name: 'Token Show',
				component: () => import(/* webpackChunkName: "advanced_trade" */ '../views/token/TokenShowContainer.vue')
			},
		]
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior() {
		return {top: 0}
	},
	routes
})

export default router

// Add navigation history tracking
let previousRoutes = []

router.beforeEach((to, from, next) => {
  // const walletStore = useWalletStore()
	//
  // if(to.path?.includes('/auth/login') && walletStore.isConnected) {
  //   next({ path: '/' })
  //   return
  // }

  // Store the current route before navigation
  previousRoutes.push(from.fullPath)
  // Keep only the last 5 routes in history
  if (previousRoutes.length > 5) {
    previousRoutes.shift()
  }

  // Store in localStorage for use across page refreshes
  localStorage.setItem('navigationHistory', JSON.stringify(previousRoutes))

  next()
})

// Helper function to get previous route
router.getPreviousRoute = function () {
	// Try to get from memory first
	if (previousRoutes.length > 0) {
		return previousRoutes[previousRoutes.length - 1]
	}

	// Otherwise try to get from localStorage
	try {
		const history = JSON.parse(localStorage.getItem('navigationHistory') || '[]')
		return history.length > 0 ? history[history.length - 1] : '/'
	} catch (e) {
		return '/'
	}
}
